var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_156_1838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.375 8H1.625C1.32663 8 1.04048 8.11853 0.829505 8.32951C0.618526 8.54048 0.5 8.82663 0.5 9.125C0.5 9.42337 0.618526 9.70952 0.829505 9.92049C1.04048 10.1315 1.32663 10.25 1.625 10.25H2.75V26C2.75 26.2984 2.86853 26.5845 3.0795 26.7955C3.29048 27.0065 3.57663 27.125 3.875 27.125C4.17337 27.125 4.45952 27.0065 4.6705 26.7955C4.88147 26.5845 5 26.2984 5 26V19.25H32V26C32 26.2984 32.1185 26.5845 32.3295 26.7955C32.5405 27.0065 32.8266 27.125 33.125 27.125C33.4234 27.125 33.7095 27.0065 33.9205 26.7955C34.1315 26.5845 34.25 26.2984 34.25 26V10.25H35.375C35.6734 10.25 35.9595 10.1315 36.1705 9.92049C36.3815 9.70952 36.5 9.42337 36.5 9.125C36.5 8.82663 36.3815 8.54048 36.1705 8.32951C35.9595 8.11853 35.6734 8 35.375 8ZM5 10.25H17.375V17H5V10.25ZM32 17H19.625V10.25H32V17ZM14 13.625C14 13.9234 13.8815 14.2095 13.6705 14.4205C13.4595 14.6315 13.1734 14.75 12.875 14.75H9.5C9.20163 14.75 8.91548 14.6315 8.7045 14.4205C8.49353 14.2095 8.375 13.9234 8.375 13.625C8.375 13.3266 8.49353 13.0405 8.7045 12.8295C8.91548 12.6185 9.20163 12.5 9.5 12.5H12.875C13.1734 12.5 13.4595 12.6185 13.6705 12.8295C13.8815 13.0405 14 13.3266 14 13.625ZM23 13.625C23 13.3266 23.1185 13.0405 23.3295 12.8295C23.5405 12.6185 23.8266 12.5 24.125 12.5H27.5C27.7984 12.5 28.0845 12.6185 28.2955 12.8295C28.5065 13.0405 28.625 13.3266 28.625 13.625C28.625 13.9234 28.5065 14.2095 28.2955 14.4205C28.0845 14.6315 27.7984 14.75 27.5 14.75H24.125C23.8266 14.75 23.5405 14.6315 23.3295 14.4205C23.1185 14.2095 23 13.9234 23 13.625Z",
    fill: "#707070"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_156_1838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesk);
export default __webpack_public_path__ + "static/media/desk.79fca3c46693c1f4c8a377b6bda27bdf.svg";
export { ForwardRef as ReactComponent };